import { Grid, Box, Container } from '@material-ui/core'
import { MetricCard } from './components/MetricCard'
import { RevenueCard } from './components/RevenueCard'
import { GoalCard } from './components/GoalCard'
import { DaySoldCard } from './components/DaySoldCard'
import { ConversionCard } from './components/ConversionCard'
import { HeaderCardsProps } from './types'
import { getSalesDataDisabledReason } from 'utils/reportDisabledFields'

export const HeaderCards = ({
  disabledFields,
  storesReport,
  lastYearReport
}: HeaderCardsProps) => {
  const variation = lastYearReport?.period.variation
  const variationAverages = variation?.averages
  const salesDisabledReason = getSalesDataDisabledReason(disabledFields)

  return (
    <Container maxWidth={false} style={{ padding: 16 }}>
      <Grid container spacing={2} style={{ paddingTop: 8 }}>
        <Grid item lg={4} md={4} sm={6} xs={12}>
          <DaySoldCard
            disabledReason={salesDisabledReason}
            daySoldValue={storesReport?.daySold.sold}
            dayGoalValue={storesReport?.dayGoals.sell}
          />
        </Grid>

        <Grid item lg={4} md={4} sm={6} xs={12}>
          <RevenueCard
            valueDisabledReason={salesDisabledReason}
            value={storesReport?.total.sold}
            lastYearPercentage={variation?.sold}
            projectionValue={storesReport?.total.projection.sold}
            projectionDisabledReason={
              disabledFields.projection?.sold
            }
          />
        </Grid>

        <Grid item lg={4} md={4} sm={12} xs={12}>
          <Box
            display="flex"
            flexDirection="column"
            height="100%"
          >
            <Box mb={1}>
              <GoalCard
                disabledReason={disabledFields.metric?.acDayGoal}
                valueDisabledReason={salesDisabledReason}
                title="META IDEAL"
                value={storesReport?.total.sold}
                expectedValue={storesReport?.total.metric.acDayGoal}
              />
            </Box>

            <GoalCard
              disabledReason={disabledFields.metric?.mainGoal}
              valueDisabledReason={salesDisabledReason}
              title="META DO MÊS"
              value={storesReport?.total.sold}
              expectedValue={storesReport?.total.metric.mainGoal}
            />
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={1} style={{ marginTop: '16px' }}>
        <Grid item lg={true} md={true} sm={12} xs={12}>
          <MetricCard
            disabledReason={salesDisabledReason}
            title="TICKET MÉDIO"
            value={storesReport?.average.tm}
            expectedValue={storesReport?.total.metric.tm}
            lastYearPercentage={variationAverages?.tm}
          />
        </Grid>

        <Grid item lg={true} md={true} sm={12} xs={12}>
          <MetricCard
            disabledReason={salesDisabledReason}
            title="PREÇO MÉDIO"
            value={storesReport?.average.pm}
            expectedValue={storesReport?.total.metric.pm}
            lastYearPercentage={variationAverages?.pm}
          />
        </Grid>

        <Grid item lg={true} md={true} sm={12} xs={12}>
          <MetricCard
            disabledReason={salesDisabledReason}
            title="Nº VENDAS"
            format="integer"
            value={storesReport?.total.sales}
            expectedValue={storesReport?.total.metric.sales}
            lastYearPercentage={variation?.total}
          />
        </Grid>

        {/* Só aparece quando alguma loja teve pessoas contadas no período */}
        {storesReport?.storesInfos?.conversion && (
          <Grid item lg={true} md={true} sm={12} xs={12}>
            <ConversionCard
              disabledReason={salesDisabledReason}
              conversion={storesReport.storesInfos.conversion}
            />
          </Grid>
        )}

        <Grid item lg={true} md={true} sm={12} xs={12}>
          <MetricCard
            disabledReason={salesDisabledReason}
            title="PEÇAS / VENDA"
            format="decimal"
            value={storesReport?.average.pv}
            expectedValue={storesReport?.total.metric.pv}
            lastYearPercentage={variationAverages?.pv}
          />
        </Grid>

        <Grid item lg={true} md={true} sm={12} xs={12}>
          <MetricCard
            disabledReason={salesDisabledReason}
            title="Nº PEÇAS"
            format="integer"
            value={storesReport?.total.items}
            expectedValue={storesReport?.total.metric.items}
            lastYearPercentage={variation?.items}
          />
        </Grid>
      </Grid>
    </Container>
  )
}
